export default "__VITE_ASSET__J0s2d28O__"